import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import type { VacancyFormField } from "../../types/VacancyTypes";
import { Input } from "./Input";
import { Textarea } from "./Textarea";
import { UploadFile } from "./UploadFile";
import type { ErrorKey } from "./ErrorMessage";

type LinkedFieldMode = "input" | "uploader";

interface LinkedUploadFieldProps {
  textField: VacancyFormField;
  uploaderField: VacancyFormField;
  mode: LinkedFieldMode;
  onModeChange: (mode: LinkedFieldMode) => void;
  textValue: string;
  onTextChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
  textError?: ErrorKey;
  fileError?: ErrorKey;
}

export const LinkedUploadField = ({
  textField,
  uploaderField,
  mode,
  onModeChange,
  textValue,
  onTextChange,
  onFileChange,
  textError,
  fileError,
}: LinkedUploadFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      {mode === "input" ? (
        textField.type === "textarea" ? (
          <Textarea
            label={textField.label}
            required={textField.required}
            id={textField.ref}
            description={textField.info}
            value={textValue}
            onChange={onTextChange}
            size="md"
            error={textError}
          />
        ) : (
          <Input
            label={textField.label}
            required={textField.required}
            id={textField.ref}
            description={textField.info}
            value={textValue}
            onChange={onTextChange}
            size="md"
            error={textError}
          />
        )
      ) : (
        <UploadFile
          label={uploaderField.label}
          required={uploaderField.required}
          id={uploaderField.ref}
          description={uploaderField.info}
          allowedMimes={uploaderField.allowedMimes}
          onChange={onFileChange}
          error={fileError}
        />
      )}

      <button
        type="button"
        className="cursor-pointer self-start font-sans text-xs font-medium text-primary-600 hover:text-primary-700"
        onClick={() => onModeChange(mode === "input" ? "uploader" : "input")}
      >
        {mode === "input"
          ? t("Vacancies.form.upload.orUploadFile")
          : t("Vacancies.form.upload.orWriteField", {
              label: textField.label,
            })}
      </button>
    </div>
  );
};
